//UserSessionInfo.js
import { UserClass } from "../../model/AppConst";

const EmptyUser =  {
    userName:"", custId:"", custName:"", userId:"",
    industryId:0,
    classNo:99999,
    email: '',
    admin:false, etrace:false,
    loginTime:"", logoutTime:"",
    viewLevel:15, initLat:37.564657445, initLon:126.974999644, initXcoord:0, initYcoord:0,
    smsUseFlag:"N", poiByGroupCd:"NO", option:"",
    needSecondAuth:"N", // 2단계 인증 필요 여부. Y or N
    secondAuthMsg:"", msg:""
};

export default class UserSessionInfo {
    sessionChecked = false;
    signedIn = false;
    user = {...EmptyUser};
    userAs = {...EmptyUser};
    needToChangePassword = false; // 비밀번호 변경 필요 여부. true면 비밀번호 변경 페이지로 이동.

    // 2단계 인증이 필요한가?
    needSecondAuth = false;

    constructor(sessionChecked, signedIn, loginData) {
        this.sessionChecked = sessionChecked;
        this.signedIn = signedIn;
        if(loginData) {
            this.user = loginData.user || {...EmptyUser};
            this.userAs = loginData.userAs || {...EmptyUser};
            // 2단계 인증이 필요한가?
            if(loginData.user) {
                this.needSecondAuth = loginData.user.needSecondAuth === 'Y' ? true : false;
            }
        }
    }

    isCustAdmin = () => this.user.classNo <= UserClass.CustAdmin.classNo;
    isEtrace = () => this.user.classNo <= UserClass.EtraceStaff.classNo;
    isSystemAdmin = () => this.user.classNo <= UserClass.EtraceAdmin.classNo;
    isDisguised = () => this.user.userId !== this.userAs.userId;

    getAutoPassword = () => {
        return 'Aa' + this.user.userId + '!!';
    };

    checkIfNeedToChangePassword = (pswd) => {
        const autoPswd = this.getAutoPassword();
        this.needToChangePassword = pswd === autoPswd ? true : false;
        return this.needToChangePassword;
    };

    /* loggable = () => {
        return new Promise((resolve, reject)=>{
            let possible = window.location.href.includes('//localhost');
            if(!possible) {
                possible = this.user.classNo <= UserClass.EtraceStaff.classNo;
            }
            //possible = false;
            if(possible) {
                resolve(true);
            }
            else {
                if(reject) {
                    reject(false);
                }
            }
        });
    }; */

    /**
     * 로컬호스트일 경우 또는 이트레이스 직원으로 로그인했을 때에만 로그를 출력할 수 있게 함.
     * @param {*} callback
     */
    /* logLocal = (callback) => {
        this.loggable().then(callback).catch(()=>{});
    }; */

    ifLocal = (callback) => {
        let isLocal = window.location.href.includes('//localhost');
        if(!isLocal) {
            isLocal = this.user.classNo <= UserClass.EtraceStaff.classNo;
        }
        if(isLocal) callback(this);
    };
}
